import { render, staticRenderFns } from "./best-taxi-service-goa.vue?vue&type=template&id=1d441eb9&scoped=true"
import script from "./best-taxi-service-goa.vue?vue&type=script&lang=js"
export * from "./best-taxi-service-goa.vue?vue&type=script&lang=js"
import style0 from "./best-taxi-service-goa.vue?vue&type=style&index=0&id=1d441eb9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d441eb9",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TaxiCard: require('/workspace/components/TaxiCard.vue').default,FaqCard: require('/workspace/components/FaqCard.vue').default})
